if (!customElements.get("lsg-faq-group")) customElements.define("lsg-faq-group", class LSGFaqGroup extends HTMLElement {
    constructor(){
        super();
        this.selectors = {
            parent: ".lsg-faq-group",
            contentItems: ".lsg-faq-content__item",
            faqButton: ".js-lsg-faq-button"
        };
        this.parent = this.querySelector(this.selectors.parent);
        this.contentItems = this.querySelectorAll(this.selectors.contentItems);
        this.faqButton = this.querySelectorAll(this.selectors.faqButton);
        this.init();
    }
    closeAllFAQs() {
        this.contentItems.forEach((el)=>{
            el.setAttribute("data-opened", false);
            el.querySelector(".lsg-faq-content__question").setAttribute("aria-expanded", false);
            el.querySelector(".lsg-faq-content__answer").setAttribute("aria-hidden", true);
        });
    }
    // Toggle FAQ Item
    toggleFAQ(id) {
        let item = this.querySelector(`.lsg-faq-content__item[data-lsg-faq-id="${id}"]`);
        let status = item.getAttribute("data-opened");
        let close_others = this.querySelector(`.lsg-faq-group__content-wrapper`).getAttribute("data-close-others");
        if (close_others === "true") this.closeAllFAQs();
        if (status === "false") {
            item.setAttribute("data-opened", true);
            item.querySelector(".lsg-faq-content__question").setAttribute("aria-expanded", true);
            item.querySelector(".lsg-faq-content__answer").setAttribute("aria-hidden", false);
        } else {
            item.setAttribute("data-opened", false);
            item.querySelector(".lsg-faq-content__question").setAttribute("aria-expanded", false);
            item.querySelector(".lsg-faq-content__answer").setAttribute("aria-hidden", true);
        }
    }
    // Open First
    openFirstFAQ() {
        let open_first = this.querySelector(`.lsg-faq-group__content-wrapper`)?.getAttribute("data-open-first");
        if (open_first === "true") {
            let id = this.contentItems[0].getAttribute("data-lsg-faq-id");
            this.toggleFAQ(id);
        }
    }
    init() {
        this.closeAllFAQs();
        this.openFirstFAQ();
        // Handle Clicks
        this.faqButton.forEach((el)=>{
            el.addEventListener("click", ()=>{
                const id = el.getAttribute("data-lsg-faq-id");
                this.toggleFAQ(id);
            });
        });
        // Section selected in Theme Editor
        document.addEventListener("shopify:section:select", function(event) {
            const $parent = event.target;
            let check = $parent.querySelector(`${parent}`);
            if (check.length > 0) document(".lsg-faq-hero__filters").querySelector(`[data-filter-id="${$parent.find(`${parent}`).getAttribute("section-id")}"]`).click();
        });
        // Section loaded in Theme Editor
        document.addEventListener("shopify:section:load", function(event) {
            const $parent = $(event.target);
            let check = $parent.querySelector(this.selectors.parent);
            if (check != null) {
                this.closeAllFAQs();
                this.openFirstFAQ();
            }
        });
        // Block selected in Theme Editor
        document.addEventListener("shopify:block:select", function(event) {
            const $block = event.target;
            const $parent = $block.querySelector(this.selectors.parent);
            if ($parent != null) {
                this.closeAllFAQs();
                this.toggleFAQ($block.getAttribute("data-lsg-faq-id"));
            }
        });
    }
});

